import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { CategoryRestrictionsProfileConfigurationService } from '@rocksoft/settings-sdk';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  CategoryRestrictionProfilePresetConfigurationApiActions,
  CategoryRestrictionProfilePresetConfigurationViewActions,
} from './category-restriction-profile-preset-configuration.actions';
import { CategoryResolvedConfigurationResolverActions } from '../category-resolved-configuration/category-resolved-configuration.actions';

@Injectable()
export class CategoryRestrictionProfilePresetConfigurationEffects {
  private readonly actions$ = inject(Actions);
  private readonly categoryRestrictionsApi = inject(CategoryRestrictionsProfileConfigurationService);

  /**
   * Restriction profile configuration has been selected for a category.
   * Effect: we add the restriction profile configuration to the category via the API.
   */
  restrictionProfileConfigurationSelectedEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(CategoryRestrictionProfilePresetConfigurationViewActions.restrictionProfileConfigurationSelected),
      mergeMap((action) => {
        const category = action.category;
        const categoryType = category.categoryType;

        return safeMap(
          this.categoryRestrictionsApi.putRestrictionsProfileToCategory({
            categoryType,
            categoryId: category.categoryId,
            setRestrictionsProfilesForCategoryCommand: {
              restrictionsProfilePresets: action.profiles.map((x) => ({
                restrictionsProfilePresetId: x.restrictionsProfilePresetId,
                models: Array.from(x.models),
              })),
            },
          }),
          () =>
            CategoryResolvedConfigurationResolverActions.categoryResolvedConfigurationRequested({
              categoryId: action.category.categoryId,
            }),
          (error) =>
            CategoryRestrictionProfilePresetConfigurationApiActions.restrictionProfileConfigurationSetFailed({ error })
        );
      })
    );
  });
}
